import CalendarSelectComponent from '../Inputs/CalendarSelectComponent'
import { useData } from '../../Context/DataContext'
import { useEffect } from 'react'

const CensusFilterComponent = () => {
  const { startDateCensus, endDateCensus, updateEndDateCensus, updateStartDateCensus, getCurrentPatients} = useData()

  // useEffect(() => {
  //   getCurrentPatients()
  // }, [startDateCensus, endDateCensus])

  return (
    <div className="flex flex-row items-center gap-2">
      <span className="text-sm text-gray-400 font-medium">Date range</span>
      <CalendarSelectComponent selectedDate={startDateCensus} handleDateChange={updateStartDateCensus}/>
      <span className="text-gray-500">-</span>
      <CalendarSelectComponent selectedDate={endDateCensus} handleDateChange={updateEndDateCensus}/>
    </div>
  )
}

export default CensusFilterComponent
